import React, { useState } from 'react';
import { Form, Header, Input, Segment } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { HtmlEditor } from 'devextreme-react/html-editor';
import TextEditor from '../../Generals/TextEditor';

const TextBlock = ({ data, saveBlock }) => {
    const { t } = useTranslation();
    const [textEn, setTextEn] = useState(data?.textEn || "");
    const [textAr, setTextAr] = useState(data?.textAr || "");
    const [readMoreTextEn, setReadMoreTextEn] = useState(data?.readMoreTextEn || "");
    const [readMoreTextAr, setReadMoreTextAr] = useState(data?.readMoreTextAr || "");


    return (
        <Segment>
            <Header>{t("EnglishText")}</Header>
            <TextEditor data={{ value: textEn, setValue: setTextEn }} showUploadImage={false} onBlur={() => saveBlock(data.blockId, { ...data, textEn })} />
            <Header>{t("ArabicText")}</Header>
            <TextEditor isArabic data={{ value: textAr, setValue: setTextAr }} showUploadImage={false} onBlur={() => saveBlock(data.blockId, { ...data, textAr })} />
            <Header>{t("ReadMore")}</Header>
            <Form>
                <Form.Group widths={"equal"}>
                    <Form.Input
                        fluid
                        content={Input}
                        placeholder={t("EnglishReadMore")}
                        value={readMoreTextEn}
                        onChange={(e, { value }) => setReadMoreTextEn(value)}
                        onBlur={() => saveBlock(data.blockId, { ...data, readMoreTextEn })}
                    />
                    <Form.Input
                        fluid
                        content={Input}
                        placeholder={t("ArabicReadMore")}
                        value={readMoreTextAr}
                        onChange={(e, { value }) => setReadMoreTextAr(value)}
                        onBlur={() => saveBlock(data.blockId, { ...data, readMoreTextAr })}
                    />
                </Form.Group>
            </Form>
        </Segment>
    );
};

export const TextBlockViewer = ({ data }) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const showReadMoreStmt = data?.readMoreTextEn || data?.readMoreTextAr || false;
    const [showMore, setShowMore] = useState(!showReadMoreStmt);
    const text = isArabic ? (data?.textAr || data?.textEn) : data?.textEn;
    return (
        <div>
            {showReadMoreStmt && <p className='tw-font-bold tw-underline tw-text-PRIMARY_50 tw-cursor-pointer' onClick={() => setShowMore(p => !p)}>{showMore ? t("Hide") : (isArabic ? data?.readMoreTextAr : data?.readMoreTextEn)}</p>}
            {showMore && <HtmlEditor readOnly value={text} style={{ border: 'none', boxShadow: 'none' }} />}
        </div>
    );
};

export default TextBlock;